(() => {
  if (!['fr', 'el'].includes(document.documentElement.lang.split('-')[0])) return;
  const config = document.getElementById('frw-review-a11y-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const exact = {
  "Previous": "previous_photo",
  "Next": "next_photo",
  "Close": "close",
  "Previous slide": "previous",
  "Next slide": "next",
  "View review image": "view_image",
  "Review Image": "image",
  "Close review form": "close_form",
  "Review form pages": "form_pages",
  "Rating": "rating_label",
  "Privacy and Terms": "privacy",
  "Review form navigation": "form_navigation",
  "Previous step": "previous_step",
  "Next step": "next_step",
  "View reviews on the Reviews Site": "reviews_site",
  "Verified checkmark": "verified",
  "Play review video": "play_video",
  "Video Thumbnail": "video_thumbnail",
  "Scroll thumbnails left": "scroll_left",
  "Scroll thumbnails right": "scroll_right",
  "Go to previous page": "previous_page",
  "Go to next page": "next_page"
};
  const patterns = [
    [/^Go to item (\d+)$/, 'go_item'],
    [/^(\d+(?:\.\d+)?) out of (\d+) stars$/, 'rating'],
    [/^(\d+(?:\.\d+)?) stars$/, 'stars'],
    [/^(\d+(?:\.\d+)?) star$/, 'star'],
    [/^Thumbnail (\d+)$/, 'thumbnail'],
    [/^Thumbnails for (\d+) items$/, 'thumbnails'],
    [/^Go to page (\d+)$/, 'page']
  ];
  const scope = '.jdgm-widget, [class*="jdgm-"], [class^="jm-"], [class*=" jm-"]';
  const attributes = ['aria-label', 'alt', 'title'];
  function translate(value) {
    if (exact[value]) return labels[exact[value]];
    for (const [pattern, key] of patterns) {
      const match = value.match(pattern);
      if (match) return labels[key].replace('[n]', match[1].replace('.', ',')).replace('[max]', match[2] || '');
    }
    return value;
  }
  function update(element) {
    if (!element.closest(scope)) return;
    for (const name of attributes) {
      const value = element.getAttribute(name);
      if (!value) continue;
      const translated = translate(value);
      if (translated && translated !== value) element.setAttribute(name, translated);
    }
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    update(root);
    root.querySelectorAll('[aria-label], [alt], [title]').forEach(update);
  }
  scan(document.body);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: attributes});
})();